export default async function fetchUrl(urlValue, _params, containerProps) {
  const { swellTheme } = containerProps;

  const value = swellTheme.resolveUrlSetting(urlValue);

  debugger;

  return value;
}
